import { createContext, useReducer } from "react";

export const AnalysisListContext = createContext();

export const analysisListReducer = (state, action) => {
    switch (action.type) {
        case 'SET_ANALYSIS_LIST':
            return {
                analysisList: action.payload
            }
        case 'CREATE_ANALYSIS_LIST':
            return {
                analysisList: [action.payload, ...state.analysisList]
            }
        case 'DELETE_ANALYSIS_LIST':
            return {
                analysisList: state.analysisList.filter(a => a._id !== action.payload._id)
            }
        default:
            return state
    };
};

export const AnalysisListContextProvider = ({ children }) => {
    const [state, dispatch] = useReducer(analysisListReducer, {
        analysisList: null
    });

    return (
        <AnalysisListContext.Provider value={{ ...state, dispatch }}>
            {children}
        </AnalysisListContext.Provider>
    );
};